var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,attrs:{"id":_vm.idName}},[(_vm.isBusy)?_c('div',[_c('b-skeleton')],1):_c('div',[_vm._v(" "+_vm._s(_vm.textValue)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }